import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  root: ({ size, textSizeRatio }: { size: number; textSizeRatio: number }) => ({
    height: size,
    width: size,
    fontSize: size / textSizeRatio,
  }),
}));

export default useStyles;
